module.exports = __webpack_public_path__ + "static/media/images.2f683d4a.svg";